(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oimano-footer"] && !Shopify.designMode) return;
  try {
    
  // Na računaru kolone su uvek otvorene; na telefonu su akordeoni.
  class OimanoFooter {
    constructor(root) {
      this.details = [...root.querySelectorAll('.oi-footer__details')];
      this.mq = window.matchMedia('(max-width: 749px)');
      this.sync = () => this.uskladi();
      this.mq.addEventListener('change', this.sync);
      this.uskladi();
    }

    uskladi() {
      const telefon = this.mq.matches;
      this.details.forEach((d) => { d.open = !telefon; });
    }
  }

  document.querySelectorAll('.oi-footer').forEach((f) => new OimanoFooter(f));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oimano-hero-karusel"] && !Shopify.designMode) return;
  try {
    
  // Skripta preko innerHTML se ne izvršava (pravilo 10), zato custom element.
  class OimanoHero extends HTMLElement {
    connectedCallback() {
      this.traka = this.querySelector('.oi-hero__traka');
      this.slajdovi = [...this.querySelectorAll('.oi-hero__slajd')];
      this.tacke = [...this.querySelectorAll('[data-oi-hero-tacka]')];
      if (!this.traka || this.slajdovi.length < 2) return;

      this.tihi = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.aktivan = 0;

      // Koji slajd je u kadru — čita se iz stvarnog položaja trake, pa je
      // tačno i kad korisnik sam prevuče prstom.
      this.posmatrac = new IntersectionObserver(
        (unosi) => {
          unosi.forEach((u) => {
            if (u.isIntersecting) this.obeleziAktivan(this.slajdovi.indexOf(u.target));
          });
        },
        { root: this.traka, threshold: 0.6 }
      );
      this.slajdovi.forEach((s) => this.posmatrac.observe(s));

      this.tacke.forEach((t) => {
        t.addEventListener('click', () => {
          this.idiNa(Number(t.dataset.oiHeroTacka));
          this.pauziraj(8000);
        });
      });

      // Automatsko listanje staje dok je kupac na baneru ili van kartice.
      ['pointerenter', 'focusin', 'touchstart'].forEach((d) =>
        this.addEventListener(d, () => this.pauziraj(8000), { passive: true })
      );
      this.traka.addEventListener('scroll', () => this.pauziraj(8000), { passive: true });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.stani();
        else this.kreni();
      });

      this.vucenje();
      this.kreni();
    }

    disconnectedCallback() {
      this.stani();
      if (this.posmatrac) this.posmatrac.disconnect();
    }

    // Vučenje mišem preko banera. Dodir se NE dira: tamo nativni skrol već
    // ima inerciju i granice koje nema smisla prepisivati.
    //
    // KLJUČNO (pravilo 12, koštalo nas je jednom): `setPointerCapture` se
    // poziva TEK kada pokazivač pređe 4px. Dok je hvatanje aktivno, pregledač
    // preusmeri i `click` na element koji je uhvatio pokazivač, dakle na traku
    // umesto na link slajda. Kad se to radilo odmah na `pointerdown`, nijedan
    // baner se nije otvarao. Ovako običan klik prođe netaknut, a vučenje se
    // gasi u rukovaocu za `click`, i to samo ako je vučenja stvarno bilo.
    //
    // Automatsko listanje se ne dira ovde: traka već sluša `scroll` i pauzira
    // sama, a vučenje menja `scrollLeft`, pa se pauza okine bez dodatnog koda.
    vucenje() {
      let aktivan = false;
      let x0 = 0;
      let s0 = 0;

      this.traka.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'touch' || e.button !== 0) return;
        aktivan = true;
        this.vuceno = false;
        x0 = e.clientX;
        s0 = this.traka.scrollLeft;
      });

      this.traka.addEventListener('pointermove', (e) => {
        if (!aktivan) return;
        const d = e.clientX - x0;
        // Sitno drhtanje miša pri kliku nije vučenje.
        if (!this.vuceno && Math.abs(d) < 4) return;

        if (!this.vuceno) {
          this.vuceno = true;
          this.classList.add('is-vuce');
          try { this.traka.setPointerCapture(e.pointerId); } catch (greska) {}
        }

        this.traka.scrollLeft = s0 - d;
      });

      const kraj = () => {
        if (!aktivan) return;
        aktivan = false;
        // Klasa se sklanja odmah, pa traka opet hvata slajdove i sama se
        // dovuče na najbliži. Zastavica `vuceno` živi do `click`-a, koji
        // stiže neposredno posle `pointerup`.
        this.classList.remove('is-vuce');
      };

      this.traka.addEventListener('pointerup', kraj);
      this.traka.addEventListener('pointercancel', kraj);
      this.traka.addEventListener('dragstart', (e) => e.preventDefault());

      // Hvatamo u capture fazi, pre nego što link slajda odradi svoje.
      this.traka.addEventListener(
        'click',
        (e) => {
          if (!this.vuceno) return;
          e.preventDefault();
          e.stopPropagation();
          this.vuceno = false;
        },
        true
      );
    }

    obeleziAktivan(i) {
      if (i < 0) return;
      this.aktivan = i;
      this.tacke.forEach((t, j) => {
        t.classList.toggle('is-aktivna', j === i);
        t.setAttribute('aria-current', j === i ? 'true' : 'false');
      });
    }

    idiNa(i) {
      const s = this.slajdovi[i];
      if (s) this.traka.scrollTo({ left: s.offsetLeft, behavior: this.tihi ? 'auto' : 'smooth' });
    }

    kreni() {
      this.stani();
      if (this.dataset.auto !== '1' || this.tihi) return;
      const ms = Number(this.dataset.interval) || 6000;
      this.tajmer = setInterval(() => {
        this.idiNa((this.aktivan + 1) % this.slajdovi.length);
      }, ms);
    }

    stani() {
      if (this.tajmer) clearInterval(this.tajmer);
      this.tajmer = null;
    }

    pauziraj(ms) {
      this.stani();
      if (this.odlaganje) clearTimeout(this.odlaganje);
      this.odlaganje = setTimeout(() => this.kreni(), ms);
    }
  }

  if (!customElements.get('oimano-hero')) customElements.define('oimano-hero', OimanoHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oimano-karusel"] && !Shopify.designMode) return;
  try {
    
  class OimanoKarusel extends HTMLElement {
    connectedCallback() {
      this.traka = this.querySelector('.oi-kar__traka');
      this.koren = this.closest('.oi-kar');
      const vrh = this.closest('.page-width');
      this.nazad = vrh ? vrh.querySelector('[data-oi-nazad]') : null;
      this.napred = vrh ? vrh.querySelector('[data-oi-napred]') : null;
      if (!this.traka) return;

      // Strelice su ZAJEDNIČKE za sve prečke (stoje u zaglavlju), pa svaka
      // traka sluša isti klik. Reaguje samo ona koja je trenutno vidljiva.
      if (this.nazad) this.nazad.addEventListener('click', () => { if (this.jeVidljiv()) this.klizi(-1); });
      if (this.napred) this.napred.addEventListener('click', () => { if (this.jeVidljiv()) this.klizi(1); });
      this.traka.addEventListener('scroll', () => this.osvezi(), { passive: true });
      window.addEventListener('resize', () => this.osvezi(), { passive: true });

      this.vuceno = false;
      this.vucenje();
      this.osvezi();

      this.querySelectorAll('[data-oi-dodaj]').forEach((b) => {
        b.addEventListener('click', () => this.dodaj(b));
      });
    }

    // Povlačenje mišem. Na dodir se ne dira ništa — nativni skrol tamo ima
    // inerciju i granice koje nema smisla prepisivati.
    //
    // KLJUČNO: `setPointerCapture` se poziva TEK kada pokazivač pređe 4px.
    // Dok je hvatanje aktivno, pretraživač preusmeri i `click` na element
    // koji je uhvatio pokazivač — dakle na traku, a ne na link u kartici.
    // Kad se to radilo na svaki `pointerdown`, nijedan proizvod se nije
    // otvarao. Sada običan klik prođe netačnut, a vučenje se gasi u
    // rukovaocu za `click`, i to samo ako je vučenja stvarno bilo.
    vucenje() {
      let aktivan = false;
      let x0 = 0;
      let s0 = 0;

      this.traka.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'touch' || e.button !== 0) return;
        aktivan = true;
        this.vuceno = false;
        x0 = e.clientX;
        s0 = this.traka.scrollLeft;
      });

      this.traka.addEventListener('pointermove', (e) => {
        if (!aktivan) return;
        const d = e.clientX - x0;
        // Sitno drhtanje miša pri kliku nije vučenje.
        if (!this.vuceno && Math.abs(d) < 4) return;

        if (!this.vuceno) {
          this.vuceno = true;
          this.classList.add('is-vuce');
          try { this.traka.setPointerCapture(e.pointerId); } catch (greska) {}
        }

        this.traka.scrollLeft = s0 - d;
        this.osvezi();
      });

      const kraj = () => {
        if (!aktivan) return;
        aktivan = false;
        // Klasa se sklanja odmah. Zastavica `vuceno` živi do `click`-a, koji
        // se ispaljuje neposredno posle `pointerup`.
        this.classList.remove('is-vuce');
      };

      this.traka.addEventListener('pointerup', kraj);
      this.traka.addEventListener('pointercancel', kraj);
      this.traka.addEventListener('dragstart', (e) => e.preventDefault());

      // Hvatamo u capture fazi, pre nego što link ili dugme odrade svoje.
      this.traka.addEventListener(
        'click',
        (e) => {
          if (!this.vuceno) return;
          e.preventDefault();
          e.stopPropagation();
          this.vuceno = false;
        },
        true
      );
    }

    klizi(smer) {
      const prva = this.traka.querySelector('.oi-kar__stavka');
      if (!prva) return;
      this.traka.scrollBy({ left: (prva.getBoundingClientRect().width + 12) * smer });
    }

    // Ploča je skrivena `hidden` atributom; njena traka ima širinu 0 i ne sme
    // da prepisuje stanje strelica preko vidljive.
    jeVidljiv() {
      const ploca = this.closest('[data-oi-ploca]');
      return !ploca || !ploca.hidden;
    }

    osvezi() {
      if (!this.jeVidljiv()) return;
      const t = this.traka;
      const visak = t.scrollWidth - t.clientWidth;
      const imaLevo = visak > 4 && t.scrollLeft > 4;
      const imaDesno = visak > 4 && t.scrollLeft < visak - 4;

      if (this.koren) {
        this.koren.style.setProperty('--oi-kar-levo', imaLevo ? '2.6rem' : '0px');
        this.koren.style.setProperty('--oi-kar-desno', imaDesno ? '2.6rem' : '0px');
      }
      if (this.nazad) this.nazad.hidden = !imaLevo;
      if (this.napred) this.napred.hidden = !imaDesno;
    }

    // Dodavanje bez napuštanja stranice. Tražimo i sekcije cart drawera, pa
    // Dawn može da ga osveži istim odgovorom — bez drugog zahteva.
    async dodaj(dugme) {
      if (this.vuceno) return;

      const korpa =
        document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      dugme.classList.add('is-radi');

      const telo = { items: [{ id: Number(dugme.dataset.varijanta), quantity: 1 }] };
      if (korpa && korpa.getSectionsToRender) {
        telo.sections = korpa.getSectionsToRender().map((s) => s.id);
        telo.sections_url = window.location.pathname;
      }

      try {
        const odgovor = await fetch(`${window.routes.cart_add_url}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify(telo),
        });
        const podaci = await odgovor.json();
        if (podaci.status) throw new Error(podaci.description || podaci.message);

        if (korpa && korpa.renderContents) {
          korpa.classList.remove('is-empty');
          korpa.renderContents(podaci);
        } else {
          window.location = window.routes.cart_url;
        }
      } catch (e) {
        // Ako išta pukne, kupac ne sme da ostane bez puta do kupovine.
        window.location = window.routes.cart_url;
      } finally {
        dugme.classList.remove('is-radi');
      }
    }
  }

  if (!customElements.get('oimano-karusel')) customElements.define('oimano-karusel', OimanoKarusel);

  // Prečke: pale/gase ploče i javljaju vidljivoj traci da preračuna strelice.
  class OimanoKarPrecke extends HTMLElement {
    connectedCallback() {
      this.precke = [...this.querySelectorAll('[data-oi-precka]')];
      this.ploce = [...this.querySelectorAll('[data-oi-ploca]')];
      if (this.precke.length < 2) return;
      this.precke.forEach((p) => p.addEventListener('click', () => this.otvori(Number(p.dataset.oiPrecka))));

      // Strelicama kroz prečke, kako WAI-ARIA propisuje za tabove. Bez ovoga
      // je red prečki bio mrtav za tastaturu: Tab ga preskoči (rovinjski
      // tabindex), a strelice nisu radile, pa se do druge ploče nije moglo
      // doći bez miša. Nađeno prolazom tastaturom 06.09.2026.
      this.addEventListener('keydown', (e) => {
        const i = this.precke.indexOf(document.activeElement);
        if (i < 0) return;
        let ciljni = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') ciljni = (i + 1) % this.precke.length;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') ciljni = (i - 1 + this.precke.length) % this.precke.length;
        else if (e.key === 'Home') ciljni = 0;
        else if (e.key === 'End') ciljni = this.precke.length - 1;
        if (ciljni === null) return;
        e.preventDefault();
        this.otvori(Number(this.precke[ciljni].dataset.oiPrecka));
        this.precke[ciljni].focus();
      });
    }

    otvori(i) {
      this.ploce.forEach((pl) => { pl.hidden = Number(pl.dataset.oiPloca) !== i; });
      this.precke.forEach((p) => {
        const jeste = Number(p.dataset.oiPrecka) === i;
        p.classList.toggle('is-aktivna', jeste);
        p.setAttribute('aria-selected', jeste ? 'true' : 'false');
        p.setAttribute('tabindex', jeste ? '0' : '-1');
      });
      // `osvezi()` u traci visi na `resize`; ovo je najkraći put da nova
      // ploča izračuna strelice sada kada konačno ima širinu.
      window.dispatchEvent(new Event('resize'));
    }
  }

  if (!customElements.get('oimano-kar-precke')) customElements.define('oimano-kar-precke', OimanoKarPrecke);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oimano-kategorije"] && !Shopify.designMode) return;
  try {
    
  class OimanoKategorije extends HTMLElement {
    connectedCallback() {
      this.traka = this.querySelector('.oi-kat__traka');
      this.koren = this.closest('.oi-kat');
      const vrh = this.closest('.page-width');
      this.nazad = vrh ? vrh.querySelector('[data-oi-nazad]') : null;
      this.napred = vrh ? vrh.querySelector('[data-oi-napred]') : null;
      if (!this.traka) return;

      if (this.nazad) this.nazad.addEventListener('click', () => this.klizi(-1));
      if (this.napred) this.napred.addEventListener('click', () => this.klizi(1));
      this.traka.addEventListener('scroll', () => this.osvezi(), { passive: true });
      window.addEventListener('resize', () => this.osvezi(), { passive: true });

      this.vuceno = false;
      this.vucenje();
      this.osvezi();
    }

    // Isto kao kod karusela: dodir se ne dira, miš dobija vučenje.
    //
    // KLJUČNO: `setPointerCapture` se poziva TEK kada pokazivač pređe 4px.
    // Dok je hvatanje aktivno, pretraživač preusmeri i `click` na element
    // koji je uhvatio pokazivač — dakle na traku, a ne na link pločice.
    // Kad se to radilo na svaki `pointerdown`, nijedna kategorija se nije
    // otvarala.
    vucenje() {
      let aktivan = false;
      let x0 = 0;
      let s0 = 0;

      this.traka.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'touch' || e.button !== 0) return;
        aktivan = true;
        this.vuceno = false;
        x0 = e.clientX;
        s0 = this.traka.scrollLeft;
      });

      this.traka.addEventListener('pointermove', (e) => {
        if (!aktivan) return;
        const d = e.clientX - x0;
        // Sitno drhtanje miša pri kliku nije vučenje.
        if (!this.vuceno && Math.abs(d) < 4) return;

        if (!this.vuceno) {
          this.vuceno = true;
          this.classList.add('is-vuce');
          try { this.traka.setPointerCapture(e.pointerId); } catch (greska) {}
        }

        this.traka.scrollLeft = s0 - d;
        this.osvezi();
      });

      const kraj = () => {
        if (!aktivan) return;
        aktivan = false;
        // Klasa se sklanja odmah. Zastavica `vuceno` živi do `click`-a, koji
        // se ispaljuje neposredno posle `pointerup`.
        this.classList.remove('is-vuce');
      };

      this.traka.addEventListener('pointerup', kraj);
      this.traka.addEventListener('pointercancel', kraj);
      this.traka.addEventListener('dragstart', (e) => e.preventDefault());

      // Hvatamo u capture fazi, pre nego što link odradi svoje.
      this.traka.addEventListener(
        'click',
        (e) => {
          if (!this.vuceno) return;
          e.preventDefault();
          e.stopPropagation();
          this.vuceno = false;
        },
        true
      );
    }

    klizi(smer) {
      const prva = this.traka.querySelector('.oi-kat__stavka');
      if (!prva) return;
      this.traka.scrollBy({ left: (prva.getBoundingClientRect().width + 12) * smer * 2 });
    }

    osvezi() {
      const t = this.traka;
      const visak = t.scrollWidth - t.clientWidth;
      const imaLevo = visak > 4 && t.scrollLeft > 4;
      const imaDesno = visak > 4 && t.scrollLeft < visak - 4;

      if (this.koren) {
        this.koren.style.setProperty('--oi-kat-levo', imaLevo ? '2.4rem' : '0px');
        this.koren.style.setProperty('--oi-kat-desno', imaDesno ? '2.4rem' : '0px');
      }
      if (this.nazad) this.nazad.hidden = !imaLevo;
      if (this.napred) this.napred.hidden = !imaDesno;
    }
  }

  if (!customElements.get('oimano-kategorije')) {
    customElements.define('oimano-kategorije', OimanoKategorije);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oimano-media"] && !Shopify.designMode) return;
  try {
    
  // Video se učitava tek na klik. Do tada stoji obična slika.
  class OimanoVideo extends HTMLElement {
    connectedCallback() {
      const dugme = this.querySelector('.oi-med__play');
      if (dugme) dugme.addEventListener('click', () => this.pusti(), { once: true });
    }

    pusti() {
      const tip = this.dataset.tip;
      const id = this.dataset.id;
      if (!id) return;

      const src =
        tip === 'vimeo'
          ? 'https://player.vimeo.com/video/' + id + '?autoplay=1'
          : 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0';

      const red = this.closest('.oi-med__red');
      const naslov = red && red.querySelector('.oi-med__naslov');

      const okvir = document.createElement('iframe');
      okvir.setAttribute('src', src);
      okvir.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
      okvir.setAttribute('allowfullscreen', '');
      okvir.setAttribute('title', naslov ? naslov.textContent.trim() : 'Video');

      this.replaceChildren(okvir);
    }
  }

  if (!customElements.get('oimano-video')) customElements.define('oimano-video', OimanoVideo);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oimano-product"]) return;
  try {
    
  class OimanoGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-oi-track]');
      this.slides = [...this.querySelectorAll('[data-oi-slide]')];
      this.thumbs = [...this.querySelectorAll('[data-oi-thumb]')];
      if (!this.track) return;

      this.thumbs.forEach((t) => {
        t.addEventListener('click', () => this.go(Number(t.dataset.oiThumb)));
      });

      this.querySelector('[data-oi-prev]')?.addEventListener('click', () => this.step(-1));
      this.querySelector('[data-oi-next]')?.addEventListener('click', () => this.step(1));

      // Uvecanje unutar okvira slike. Vezano na [data-oi-lupa], pa video
      // slajdovi i cvorovi koje ubaci TeeInBlue ostaju nedirnuti.
      // Straza: u editoru teme element moze da se odveze i ponovo veze, a
      // rukovaoci se ne smeju udvostruciti.
      if (!this.lupe) {
        this.lupe = new Map();
        this.postaviLupu();
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) this.markActive(Number(e.target.dataset.oiSlide));
          });
        },
        { root: this.track, threshold: 0.6 }
      );
      this.slides.forEach((s) => this.observer.observe(s));
    }

    get index() {
      return this.thumbs.findIndex((t) => t.classList.contains('is-active'));
    }

    step(delta) {
      const next = Math.min(Math.max(this.index + delta, 0), this.slides.length - 1);
      this.go(next);
    }

    go(i) {
      const slide = this.slides[i];
      if (!slide) return;
      this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
      this.markActive(i);
    }

    markActive(i) {
      this.thumbs.forEach((t, n) => t.classList.toggle('is-active', n === i));

      // Zum se gasi na svim slajdovima osim na trenutnom: ako kupac
      // prelista galeriju, uvecanje ne ostaje zakljucano na staroj slici
      // (a na dodiru se time vraca i normalno klizanje vrteske).
      this.lupe?.forEach((st, slajd) => {
        if (Number(slajd.dataset.oiSlide) !== i) st.ugasi();
      });
    }

    /* ---------- uvecanje UNUTAR okvira slike ----------

       Sloj uvecanja je apsolutno pozicioniran unutar slajda, a slajd ima
       `overflow: hidden` — uvecana slika je zato uvek podsecena na okvir
       slike i NISTA ne izlazi iz njega ni ne prekriva stranicu. Nema
       dijaloga, nema druge slike, nema popupa.

       OSTRINA: sloj ne razvlaci sliku sa stranice (upravo to je bilo mutno),
       nego koristi POSEBAN, veci izvor iz `data-oi-lupa-src` (1600px). Taj
       izvor NE stoji u `src` nijedne slike, pa se pri ucitavanju stranice ne
       skida — LCP ostaje nedirnut. JS ga trazi tek pri prvom prelasku misem
       ili prvom dodiru.

       Namerno se ceka `decode()` pre nego sto se sloj upali, umesto da se
       razvucena mala slika pokaze kao privremena podloga: mutna slika je
       bas ono na sta se kupac zalio, pa je bolje da zum krene stotinak
       milisekundi kasnije nego da ijedan kadar bude mutan. Posle prvog puta
       slika je u kesu i zum je trenutan. */
    postaviLupu() {
      this.slides
        .filter((slajd) => slajd.hasAttribute('data-oi-lupa'))
        .forEach((slajd) => {
          const sloj = slajd.querySelector('[data-oi-lupa-sloj]');
          if (!sloj) return;

          // stanje po slajdu: kadar u procentima + tekuci dodir
          const st = { x: 50, y: 50, dodir: null, cekanje: null };

          const iscrtaj = () => {
            sloj.style.backgroundPosition = st.x + '% ' + st.y + '%';
          };

          const ukljuci = () => {
            slajd.classList.add('is-lupa-aktivna');
            iscrtaj();
          };

          const ugasi = () => {
            slajd.classList.remove('is-lupa-aktivna');
            st.dodir = null;
            st.x = 50;
            st.y = 50;
            iscrtaj();
          };

          st.ugasi = ugasi;
          this.lupe.set(slajd, st);

          /* Ostar izvor: skida se i dekodira samo jednom, na zahtev.
             Ako padne, `cekanje` se vraca na null pa se sledeci put pokusava
             ponovo; do tada slika jednostavno nema zum. */
          const spremi = () => {
            if (st.cekanje) return st.cekanje;
            const url = slajd.dataset.oiLupaSrc;
            if (!url) return Promise.resolve(false);

            const im = new Image();
            im.decoding = 'async';
            im.src = url;
            const cekaj = im.decode
              ? im.decode()
              : new Promise((ok, greska) => {
                  im.onload = ok;
                  im.onerror = greska;
                });

            st.cekanje = cekaj
              .then(() => {
                sloj.style.backgroundImage = 'url("' + url + '")';
                return true;
              })
              .catch(() => {
                st.cekanje = null;
                return false;
              });
            return st.cekanje;
          };

          const izKursora = (e) => {
            const r = slajd.getBoundingClientRect();
            if (!r.width || !r.height) return;
            st.x = Math.min(Math.max(((e.clientX - r.left) / r.width) * 100, 0), 100);
            st.y = Math.min(Math.max(((e.clientY - r.top) / r.height) * 100, 0), 100);
          };

          /* ----- mis i pero: zum traje dok je kursor na slici ----- */

          slajd.addEventListener('pointerenter', (e) => {
            if (e.pointerType === 'touch') return;
            izKursora(e);
            iscrtaj();
            spremi().then((ok) => {
              // u medjuvremenu je kursor mogao da izadje sa slike
              if (ok && slajd.matches(':hover')) ukljuci();
            });
          });

          slajd.addEventListener('pointerleave', (e) => {
            if (e.pointerType === 'touch') return;
            ugasi();
          });

          /* ----- dodir: tap ukljucuje/gasi, prevlacenje pomera kadar -----

             Kad zum NIJE ukljucen, slajd ima podrazumevan touch-action, pa
             zamah levo-desno pregledac uzima sebi za klizanje vrteske i
             posalje `pointercancel` — dodir se tada odbacuje i zum se ne
             ukljucuje slucajno. Kad zum JESTE ukljucen, CSS gasi
             touch-action na tom slajdu, pa ceo pokret prsta dobijamo mi i
             njime pomeramo kadar; vrteska se ne pomera. Tap vraca sliku. */

          slajd.addEventListener('pointerdown', (e) => {
            if (e.pointerType !== 'touch') return;
            const r = slajd.getBoundingClientRect();
            const f =
              parseFloat(getComputedStyle(slajd).getPropertyValue('--oi-lupa-faktor')) || 2.2;
            st.dodir = {
              x: e.clientX,
              y: e.clientY,
              px: st.x,
              py: st.y,
              // opseg pomeranja kadra u pikselima po osi
              opsegX: r.width * (f - 1),
              opsegY: r.height * (f - 1),
              vuceno: false,
            };
            if (!slajd.classList.contains('is-lupa-aktivna')) spremi();
          });

          slajd.addEventListener('pointermove', (e) => {
            if (e.pointerType !== 'touch') {
              /* Mis/pero: kadar prati kursor, pa kupac gleda tacno ono na
                 sta pokazuje. Racuna se i dok se ostar izvor jos ucitava,
                 da zum ne krene na mestu na kom je kursor bio na ulasku. */
              if (!slajd.classList.contains('is-lupa-aktivna') && !st.cekanje) return;
              izKursora(e);
              iscrtaj();
              return;
            }
            if (!st.dodir) return;
            const dx = e.clientX - st.dodir.x;
            const dy = e.clientY - st.dodir.y;
            // prag od 10px razdvaja tap od prevlacenja
            if (!st.dodir.vuceno && Math.abs(dx) < 10 && Math.abs(dy) < 10) return;
            st.dodir.vuceno = true;
            if (!slajd.classList.contains('is-lupa-aktivna')) return;
            st.x = st.dodir.opsegX
              ? Math.min(Math.max(st.dodir.px - (dx / st.dodir.opsegX) * 100, 0), 100)
              : 50;
            st.y = st.dodir.opsegY
              ? Math.min(Math.max(st.dodir.py - (dy / st.dodir.opsegY) * 100, 0), 100)
              : 50;
            iscrtaj();
          });

          slajd.addEventListener('pointerup', (e) => {
            if (e.pointerType !== 'touch') return;
            const d = st.dodir;
            st.dodir = null;
            if (!d || d.vuceno) return; // prevlacenje nije tap

            if (slajd.classList.contains('is-lupa-aktivna')) {
              ugasi();
              return;
            }
            izKursora(e);
            iscrtaj();
            spremi().then((ok) => {
              // ako je kupac u medjuvremenu ponovo dotakao sliku, ne diramo
              if (ok && !st.dodir) ukljuci();
            });
          });

          // pregledac je preuzeo pokret (klizanje vrteske) — dodir se odbacuje
          slajd.addEventListener('pointercancel', () => {
            st.dodir = null;
          });
        });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  if (!customElements.get('oimano-gallery')) {
    customElements.define('oimano-gallery', OimanoGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oimano-slava"] && !Shopify.designMode) return;
  try {
    
  class OimanoSlava extends HTMLElement {
    connectedCallback() {
      this.traka = this.querySelector('.oi-sl__traka');
      this.koren = this.closest('.oi-sl');
      const vrh = this.closest('.page-width');
      this.nazad = vrh ? vrh.querySelector('[data-oi-nazad]') : null;
      this.napred = vrh ? vrh.querySelector('[data-oi-napred]') : null;
      if (!this.traka) return;

      if (this.nazad) this.nazad.addEventListener('click', () => this.klizi(-1));
      if (this.napred) this.napred.addEventListener('click', () => this.klizi(1));
      this.traka.addEventListener('scroll', () => this.osvezi(), { passive: true });
      window.addEventListener('resize', () => this.osvezi(), { passive: true });

      this.vuceno = false;
      this.vucenje();
      this.osvezi();
    }

    // Obrazac iz zamke 12. Pokazivač se hvata TEK posle 4px — inače pretraživač
    // preusmeri i `click` na traku i nijedan proizvod se ne otvara.
    vucenje() {
      let aktivan = false;
      let x0 = 0;
      let s0 = 0;

      this.traka.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'touch' || e.button !== 0) return;
        aktivan = true;
        this.vuceno = false;
        x0 = e.clientX;
        s0 = this.traka.scrollLeft;
      });

      this.traka.addEventListener('pointermove', (e) => {
        if (!aktivan) return;
        const d = e.clientX - x0;
        if (!this.vuceno && Math.abs(d) < 4) return;

        if (!this.vuceno) {
          this.vuceno = true;
          this.classList.add('is-vuce');
          try { this.traka.setPointerCapture(e.pointerId); } catch (greska) {}
        }

        this.traka.scrollLeft = s0 - d;
        this.osvezi();
      });

      const kraj = () => {
        if (!aktivan) return;
        aktivan = false;
        this.classList.remove('is-vuce');
      };

      this.traka.addEventListener('pointerup', kraj);
      this.traka.addEventListener('pointercancel', kraj);
      this.traka.addEventListener('dragstart', (e) => e.preventDefault());

      this.traka.addEventListener(
        'click',
        (e) => {
          if (!this.vuceno) return;
          e.preventDefault();
          e.stopPropagation();
          this.vuceno = false;
        },
        true
      );
    }

    klizi(smer) {
      const prva = this.traka.querySelector('.oi-sl__stavka');
      if (!prva) return;
      this.traka.scrollBy({ left: (prva.getBoundingClientRect().width + 12) * smer });
    }

    osvezi() {
      const t = this.traka;
      const visak = t.scrollWidth - t.clientWidth;
      const imaLevo = visak > 4 && t.scrollLeft > 4;
      const imaDesno = visak > 4 && t.scrollLeft < visak - 4;

      if (this.koren) {
        this.koren.style.setProperty('--oi-sl-levo', imaLevo ? '2.6rem' : '0px');
        this.koren.style.setProperty('--oi-sl-desno', imaDesno ? '2.6rem' : '0px');
      }
      if (this.nazad) this.nazad.hidden = !imaLevo;
      if (this.napred) this.napred.hidden = !imaDesno;
    }
  }

  if (!customElements.get('oimano-slava')) customElements.define('oimano-slava', OimanoSlava);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oimano-sticky-atc"]) return;
  try {
    
  class OimanoStickyAtc extends HTMLElement {
    connectedCallback() {
      this.form =
        document.querySelector('product-form form[action*="/cart/add"]') ||
        document.querySelector('form[action*="/cart/add"]');
      if (!this.form) return;

      this.realButton = this.form.querySelector('[type="submit"][name="add"]');
      this.proxyButton = this.querySelector('[data-oi-sticky-add]');
      if (!this.realButton || !this.proxyButton) return;

      this.priceEl = this.querySelector('[data-oi-sticky-price]');
      this.labelEl = this.querySelector('[data-oi-sticky-label]');
      this.pocetniLabel = this.labelEl ? this.labelEl.textContent.trim() : '';

      this.pratiVidljivost();
      this.pratiCenu();
      this.pratiDostupnost();

      this.proxyButton.addEventListener('click', () => {
        // Klikni pravo dugme: sva validacija i svaka aplikacija zakačena
        // na formu rade normalno.
        this.realButton.click();
      });
    }

    pratiVidljivost() {
      const izmeri = () => {
        const rect = this.realButton.getBoundingClientRect();
        // Pravo dugme je u celosti prošlo iznad vidnog polja.
        this.classList.toggle('is-visible', rect.bottom < 0);
      };

      let zakazano = false;
      this.onScroll = () => {
        if (zakazano) return;
        zakazano = true;
        requestAnimationFrame(() => {
          zakazano = false;
          izmeri();
        });
      };

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });

      this.vidljivost = new IntersectionObserver(izmeri, { threshold: [0, 0.01, 1] });
      this.vidljivost.observe(this.realButton);

      this.onPageShow = izmeri;
      window.addEventListener('pageshow', this.onPageShow);
      izmeri();
    }

    // Cena dolazi iz istog događaja koji hrani i glavno dugme, pa se dve
    // cene nikada ne raziđu. Ako događaja nema (proizvod bez pakovanja),
    // prepisujemo cenu iz glavnog dugmeta.
    pratiCenu() {
      if (!this.priceEl) return;

      this.form.addEventListener('oi:total-change', (e) => {
        const detalj = e.detail || {};
        if (detalj.totalMoney) this.priceEl.textContent = detalj.totalMoney;
      });

      const izvor = this.form.querySelector('[data-oi-atc-price]');
      if (!izvor) return;

      const prepisi = () => {
        const tekst = izvor.textContent.replace(/^[\s —-]+/, '').trim();
        if (tekst) this.priceEl.textContent = tekst;
      };

      prepisi();
      this.cena = new MutationObserver(prepisi);
      this.cena.observe(izvor, { childList: true, subtree: true, characterData: true });
    }

    // Prepisuje se SAMO stanje dostupnosti, ne i tekst. Tekst glavnog dugmeta
    // nosi cenu i predug je za traku.
    pratiDostupnost() {
      const uskladi = () => {
        const ugaseno = this.realButton.hasAttribute('disabled');
        this.proxyButton.toggleAttribute('disabled', ugaseno);
        if (this.labelEl) {
          this.labelEl.textContent = ugaseno
            ? this.dataset.rasprodato || this.pocetniLabel
            : this.pocetniLabel;
        }
      };

      uskladi();
      this.dostupnost = new MutationObserver(uskladi);
      this.dostupnost.observe(this.realButton, {
        attributes: true,
        attributeFilter: ['disabled'],
      });
    }

    disconnectedCallback() {
      if (this.onScroll) {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }
      if (this.onPageShow) window.removeEventListener('pageshow', this.onPageShow);
      if (this.vidljivost) this.vidljivost.disconnect();
      if (this.cena) this.cena.disconnect();
      if (this.dostupnost) this.dostupnost.disconnect();
    }
  }

  if (!customElements.get('oimano-sticky-atc')) {
    customElements.define('oimano-sticky-atc', OimanoStickyAtc);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oimano-stories"] && !Shopify.designMode) return;
  try {
    
  class OimanoStories extends HTMLElement {
    connectedCallback() {
      const dugmad = [...this.querySelectorAll('button.oi-pr__dugme')];

      this.stavke = dugmad.map(function (b) {
        return { src: b.dataset.src, naslov: b.dataset.naslov || '' };
      });

      dugmad.forEach((b, i) => {
        b.addEventListener('click', () => this.otvori(i));
      });

      this.naTaster = (e) => {
        if (e.key === 'Escape') this.zatvori();
        if (e.key === 'ArrowRight') this.pomeri(1);
        if (e.key === 'ArrowLeft') this.pomeri(-1);
      };
    }

    otvori(i) {
      if (this.pl) this.zatvori();
      this.i = i;
      this.tih = true;

      const pl = document.createElement('div');
      pl.className = 'oi-pl';
      pl.setAttribute('role', 'dialog');
      pl.setAttribute('aria-modal', 'true');

      const vrh = document.createElement('div');
      vrh.className = 'oi-pl__vrh';

      const trake = document.createElement('div');
      trake.className = 'oi-pl__trake';
      this.puni = this.stavke.map(function () {
        const t = document.createElement('span');
        t.className = 'oi-pl__traka';
        const p = document.createElement('span');
        p.className = 'oi-pl__pun';
        t.appendChild(p);
        trake.appendChild(t);
        return p;
      });

      this.dugmeTon = document.createElement('button');
      this.dugmeTon.type = 'button';
      this.dugmeTon.className = 'oi-pl__akcija';
      this.dugmeTon.setAttribute('aria-label', this.dataset.ton || 'Zvuk');
      this.dugmeTon.textContent = '🔇';
      this.dugmeTon.addEventListener('click', () => this.prebaciTon());

      const x = document.createElement('button');
      x.type = 'button';
      x.className = 'oi-pl__akcija';
      x.setAttribute('aria-label', this.dataset.zatvori || 'Zatvori');
      x.textContent = '✕';
      x.addEventListener('click', () => this.zatvori());

      vrh.append(trake, this.dugmeTon, x);

      const scena = document.createElement('div');
      scena.className = 'oi-pl__scena';

      this.video = document.createElement('video');
      this.video.className = 'oi-pl__video';
      this.video.playsInline = true;
      this.video.muted = true;
      this.video.preload = 'auto';
      this.video.addEventListener('ended', () => this.pomeri(1));

      this.naslov = document.createElement('p');
      this.naslov.className = 'oi-pl__naslov';

      const nazad = document.createElement('button');
      nazad.type = 'button';
      nazad.className = 'oi-pl__zona oi-pl__zona--nazad';
      nazad.setAttribute('aria-label', 'Prethodni');
      nazad.addEventListener('click', () => this.pomeri(-1));

      const napred = document.createElement('button');
      napred.type = 'button';
      napred.className = 'oi-pl__zona oi-pl__zona--napred';
      napred.setAttribute('aria-label', 'Sledeći');
      napred.addEventListener('click', () => this.pomeri(1));

      scena.append(this.video, this.naslov, nazad, napred);
      pl.append(vrh, scena);
      document.body.appendChild(pl);

      this.pl = pl;
      this.prethodniOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', this.naTaster);

      this.prevlacenje(scena);
      this.pusti();
      x.focus();
    }

    prevlacenje(scena) {
      let x0 = null;
      scena.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      scena.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        const d = e.changedTouches[0].clientX - x0;
        if (Math.abs(d) > 50) this.pomeri(d < 0 ? 1 : -1);
        x0 = null;
      }, { passive: true });
    }

    pusti() {
      const s = this.stavke[this.i];
      if (!s) return;

      this.puni.forEach((p, k) => {
        p.style.width = k < this.i ? '100%' : '0';
      });

      this.video.src = s.src;
      this.video.muted = this.tih;
      this.naslov.textContent = s.naslov;
      this.naslov.hidden = !s.naslov;

      const igraj = this.video.play();
      if (igraj && igraj.catch) igraj.catch(function () {});

      cancelAnimationFrame(this.raf);
      const tik = () => {
        if (!this.pl) return;
        const d = this.video.duration;
        if (d && isFinite(d)) {
          const p = Math.min(100, (this.video.currentTime / d) * 100);
          this.puni[this.i].style.width = p + '%';
        }
        this.raf = requestAnimationFrame(tik);
      };
      this.raf = requestAnimationFrame(tik);
    }

    pomeri(k) {
      const sledeci = this.i + k;
      if (sledeci < 0) return;
      if (sledeci >= this.stavke.length) { this.zatvori(); return; }
      this.i = sledeci;
      this.pusti();
    }

    prebaciTon() {
      this.tih = !this.tih;
      this.video.muted = this.tih;
      this.dugmeTon.textContent = this.tih ? '🔇' : '🔊';
    }

    zatvori() {
      cancelAnimationFrame(this.raf);
      document.removeEventListener('keydown', this.naTaster);
      document.body.style.overflow = this.prethodniOverflow || '';
      if (this.video) {
        this.video.pause();
        this.video.removeAttribute('src');
        this.video.load();
      }
      if (this.pl) {
        this.pl.remove();
        this.pl = null;
      }
    }

    disconnectedCallback() { this.zatvori(); }
  }

  if (!customElements.get('oimano-stories')) customElements.define('oimano-stories', OimanoStories);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oimano-tabs"] && !Shopify.designMode) return;
  try {
    
  class OimanoTabs extends HTMLElement {
    connectedCallback() {
      this.dugmad = [...this.querySelectorAll('.oi-tabs__btn')];
      this.paneli = [...this.querySelectorAll('.oi-tabs__panel')];
      this.mq = window.matchMedia('(min-width: 750px)');

      this.dugmad.forEach((d, idx) => {
        d.addEventListener('click', () => this.klik(idx));
      });

      this.promena = () => this.uskladi();
      this.mq.addEventListener('change', this.promena);
      this.uskladi();
    }

    disconnectedCallback() {
      if (this.mq) this.mq.removeEventListener('change', this.promena);
    }

    // Na računaru je uvek tačno jedan tab otvoren; na telefonu se svaki
    // otvara i zatvara nezavisno.
    klik(idx) {
      if (this.mq.matches) {
        this.otvori(idx);
      } else {
        this.postavi(idx, this.paneli[idx].hidden);
      }
    }

    otvori(idx) {
      this.paneli.forEach((_, k) => this.postavi(k, k === idx));
    }

    postavi(idx, otvoren) {
      this.paneli[idx].hidden = !otvoren;
      this.dugmad[idx].setAttribute('aria-expanded', otvoren ? 'true' : 'false');
      this.dugmad[idx].classList.toggle('is-active', otvoren);
    }

    uskladi() {
      if (this.mq.matches) {
        const aktivan = this.dugmad.findIndex((d) => d.classList.contains('is-active'));
        this.otvori(aktivan === -1 ? 0 : aktivan);
      } else {
        this.paneli.forEach((_, k) => this.postavi(k, k === 0));
      }
    }
  }

  if (!customElements.get('oimano-tabs')) customElements.define('oimano-tabs', OimanoTabs);

  } catch(e) { console.error(e); }
})();
})();
